var facebookECommerce = {
  fe_purchaseModel: {
    value: 0,
    currency: 'GBP'
  },
  initialize: function initialize() {
    if (!window.fbq) this.dropSnippet();
  },
  dropSnippet: function dropSnippet() {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', clientData.config.analytics.facebookAdsId);
    fbq('track', 'PageView');
  },
  dropSnippet_LAZY: function dropSnippet_LAZY() {
    var isFbInjected = false;
    var injectFb = function injectFb() {
      if (!isFbInjected) {
        isFbInjected = true;
        console.log('injecting facebook');
        !function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', clientData.config.analytics.facebookAdsId);
        fbq('track', 'PageView');
      }
    };
    $(window).bind('click', function () {
      injectFb();
    });
    $(window).bind('scroll', function () {
      injectFb();
    });
    $(window).bind('mousemove', function () {
      injectFb();
    });
    $(window).bind('touchstart', function () {
      injectFb();
    });
  },
  createFEPurchase: function createFEPurchase(orderData) {
    var _clientData$sjData;
    var res = $.extend({}, this.fe_purchaseModel);
    // res.value = orderData.total;
    res.value = ((_clientData$sjData = clientData.sjData) === null || _clientData$sjData === void 0 || (_clientData$sjData = _clientData$sjData.topLevelService) === null || _clientData$sjData === void 0 ? void 0 : _clientData$sjData.withoutVat) || orderData.subTotal;
    return res;
  },
  onPurchase: function onPurchase(purchase) {
    fbq('track', 'Purchase', {
      value: purchase.value,
      currency: purchase.currency
    });
  }
};
export { facebookECommerce };